<template>
    <div class="mobile-page">
        <div class="news-box" :style="{margin:'0 '+ configData.prConfig.val +'px',marginTop: configData.mbConfig.val+'px',background:configData.bgColor}">
            <div class="item" :style="{color:configData.txtColor.color[0].item}">
                <div class="img-box"><img :src="configData.logoConfig.url" alt=""></div>
                <div class="right-box">
                    {{configData.listConfig.list[0].info[0].value}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {image} from '@/utils/util';

    export default {
        name: "notice",
        sort: 200,
        cname: '公告',
        type: 0, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconxinwenbobao1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        mounted() {

        },
        data() {
            return {
                defaultConfig: {
                    name: "notice",
                    cname: '公告',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        bgColor: {
                            title: '背景颜色',
                            tab: 1,
                            name: 'colors',
                            default: [{
                                item: '#f5f5f5'
                            }],
                            color: [
                                {
                                    item: '#f5f5f5'
                                }
                            ]
                        },
                        txtColor: {
                            title: '文字颜色',
                            tab: 1,
                            name: 'colors',
                            default: [
                                {
                                    item: '#333'
                                }
                            ],
                            color: [
                                {
                                    item: '#333'
                                }
                            ]
                        },
                        prConfig: {
                            title: '背景边距',
                            tab: 1,
                            name: 'slider',
                            val: 10,
                            min: 0
                        },
                        // 页面间距
                        mbConfig: {
                            title: '页面间距',
                            tab: 1,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                        logoConfig: {
                            header: '公告图标',
                            title: '',
                            tab: 0,
                            name: 'editorimage',
                            type: 1,
                            url: image('/assets/images/notice_01.png')
                        },
                        listConfig: {
                            title: '最多可添加10个版块；鼠标拖拽左侧圆点可调整版块顺序',
                            tab: 0,
                            name: 'list',
                            maxList: 10,
                            list: [
                                {
                                    info: [
                                        {
                                            title: '公告',
                                            value: '',
                                            tips: '',
                                        },
                                        {
                                            title: '链接',
                                            value: '',
                                            tips: '请选择链接',
                                        }
                                    ]
                                }
                            ]
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .box {
        height: 20px;
        background: #F5F5F5;
    }

    .pageOn{
        border-radius: 6px!important
    }
    .news-box {
        .item {
            display: flex;
            align-items: center;
            height: 30px;
            margin: 0 7px;
            .img-box {
                width: 75px;
                height: 18px;
                border-right: 1px solid #ddd;
                padding-right: 10px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .right-box {
                flex: 1;
                padding: 0 20px 0 10px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;;
                background-image: url("~@/assets/images/right.png");
                background-size: 20px 20px;
                background-position: right center;
                background-repeat: no-repeat;
            }
        }
    }
</style>
